import React from "react";
import { motion } from "framer-motion";
import PartnershipsSection from "../components/Partners/PartnershipsSection";
import PartnershipsAbout from "../components/Partners/partners-about";
import Footer from "../components/Footer";
import Topbar from "../components/Topbar";
import Navbar from "../components/Navbar";
import Banner from "../components/PartnersBanner";

function Offers() {
  return (
    <>
      <Topbar />
      <Navbar />
      <Banner />

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        transition={{ staggerChildren: 0.25 }}
        variants={{
          hidden: { opacity: 0, y: 50 },
          visible: { opacity: 1, y: 0 },
        }}
      >
        <motion.div
          variants={{
            hidden: { opacity: 0, y: 40 },
            visible: { opacity: 1, y: 0 },
          }}
        >
          <PartnershipsAbout />
        </motion.div>
        <motion.div
          variants={{
            hidden: { opacity: 0, y: 40 },
            visible: { opacity: 1, y: 0 },
          }}
        >
          <PartnershipsSection />
        </motion.div>
      </motion.div>

      <Footer />
    </>
  );
}

export default Offers;
